import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import Layout from "../components/layout/Layout";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import Dashboard from "../pages/Dashboard/Dashboard";
import Categories from "../pages/Categories/Categories";
import Transactions from "../pages/Transactions/Transactions";
import NotFound from "../pages/NotFound";
import Landing from "../pages/Landing/Landing";
import ProtectedRoute from "./ProtectedRoute";
import AuthRedirect from "./AuthRedirect";
import Manager from "../pages/Manager/Manager";
import Investments from "../pages/Investments/Investments";
import Calculators from "../pages/Calculators/Calculators";
import NettWorth from "../pages/Manager/NettWorth/NettWorth";
import Cashflow from "../pages/Manager/Cashflow/Cashflow";
import Budget from "../pages/Manager/Budget/Budget";
import Goals from "../pages/Manager/Goals/Goals";
import Help from "../pages/Help/Help";
import VerifyEmail from "../pages/VerifyEmail";
import Settings from "../pages/Settings/Settings";
import VerifyEmailChange from "../pages/VerifyEmailChange";

function AppRouter() {
	return (
		<Router>
			<Routes>
				<Route element={<AuthRedirect />}>
					<Route path="/" element={<Landing />} />
					<Route path="/login" element={<Login />} />
					<Route path="/register" element={<Register />} />
					<Route path="/verify-email" element={<VerifyEmail />} />
					<Route
						path="/verify-email-change"
						element={<VerifyEmailChange />}
					/>
				</Route>

				{/* Layout dla autoryzowanych użytkowników */}
				<Route path="/" element={<Layout />}>
					<Route element={<ProtectedRoute />}>
						<Route path="/dashboard" element={<Dashboard />} />
						<Route path="/manager" element={<Manager />}>
							<Route
								index
								element={<Navigate to="nettworth" replace />}
							/>
							<Route path="nettworth" element={<NettWorth />} />
							<Route path="cashflow" element={<Cashflow />} />
							<Route path="goals" element={<Goals />} />
							<Route path="budget" element={<Budget />} />
						</Route>
						<Route path="/investments" element={<Investments />} />
						<Route path="/calculators" element={<Calculators />} />
						<Route path="/categories" element={<Categories />} />
						<Route
							path="/transactions"
							element={<Transactions />}
						/>
						<Route path="/help" element={<Help />} />
						<Route path="/settings" element={<Settings />} />
					</Route>
				</Route>
				<Route path="*" element={<NotFound />} />
			</Routes>
		</Router>
	);
}

export default AppRouter;
